module.exports = __webpack_public_path__ + "img/cog_run.4aa1397a.gif";